import { useMemo, useState } from "react";
import PageShell from "../components/website-Generator/PageShell";
import { renderDevPreview } from "../services/devRenderService";

/* keep your existing samples object here */
const samples = {
    academy: {
        label: "Academy",
        payload: {
            businessName: "Shriansh Football Academy",
            industry: "Education",
            subIndustry: "Sports Academy",
            themeKey: "premium-dark",
            desiredLayoutStyle: "premium",
            visualTone: "modern",
            preferredSectionDensity: "balanced",
            brandStyle: "Premium",
            toneOfVoice: "Professional",
            primaryGoal: "Generate Leads",
            primaryCallToAction: "Book a Trial",
            debugVariants: {
                "academy-home-hero": 2,
                "academy-home-programs": 2,
                "academy-home-categories": 2,
                "academy-home-coaches": 2,
                "academy-home-process": 2,
                "academy-home-cta": 2
            },
            data: {
                brand: {
                    name: "Shriansh Football Academy",
                    tagline: "Train smarter. Play stronger."
                },
                meta: {
                    themeKey: "premium-dark"
                },
                hero: {
                    eyebrow: "Elite Football Training",
                    title: "Professional Football Coaching for Young Players",
                    subtitle: "Structured programs, expert coaches, and performance-focused training for every age group.",
                    primaryCta: "Book a Trial",
                    secondaryCta: "View Programs",
                    trustLine: "Trusted by 500+ students and parents"
                },
                services: [
                    {
                        title: "Beginner Football Program",
                        description: "Foundation-level coaching for young players starting their football journey."
                    },
                    {
                        title: "Advanced Match Training",
                        description: "Tactical, fitness, and skill-based training for competitive players."
                    },
                    {
                        title: "Weekend Coaching Camp",
                        description: "Flexible weekend sessions for school students and working parents."
                    }
                ],
                features: [
                    {
                        title: "Certified Coaches",
                        description: "Learn from experienced football trainers."
                    },
                    {
                        title: "Age-wise Batches",
                        description: "Programs designed for each age and skill level."
                    },
                    {
                        title: "Performance Tracking",
                        description: "Regular feedback and progress reports."
                    }
                ],
                cta: {
                    title: "Ready to start training?",
                    subtitle: "Book your first trial session today.",
                    buttonText: "Book Trial"
                },
                ShowcaseItems: [
                    {
                        Title: "Foundation Football Program",
                        Subtitle: "Age 6–10",
                        Description: "Core football skills, movement, passing, balance, and confidence building.",
                        Badge: "Beginner",
                        Meta: ["6–10 years", "Mon, Wed, Fri", "Main Turf Ground"]
                    },
                    {
                        Title: "Advanced Match Training",
                        Subtitle: "Age 11–16",
                        Description: "Tactical match preparation, stamina, position training, and game intelligence.",
                        Badge: "Advanced",
                        Meta: ["11–16 years", "Tue, Thu, Sat", "Performance Ground"]
                    }
                ],
                DetailDensity: {
                    Academy: {
                        Programs: [
                            {
                                Title: "Foundation Football Program",
                                Subtitle: "Beginner training",
                                Description: "Core football skills, movement, passing, balance, and confidence building.",
                                AgeGroup: "6–10 years",
                                BatchType: "Beginner",
                                Schedule: "Mon, Wed, Fri",
                                Venue: "Main Turf Ground",
                                CtaText: "Book Trial",
                                Tags: ["Ball control", "Fitness", "Team play"]
                            },
                            {
                                Title: "Advanced Match Training",
                                Subtitle: "Competitive batch",
                                Description: "Tactical match preparation, stamina, position training, and game intelligence.",
                                AgeGroup: "11–16 years",
                                BatchType: "Advanced",
                                Schedule: "Tue, Thu, Sat",
                                Venue: "Performance Ground",
                                CtaText: "Book Trial",
                                Tags: ["Tactics", "Match play", "Performance"]
                            }
                        ],
                        Coaches: [],
                        Facilities: []
                    }
                }
            }
        }
    },

    realEstate: {
        label: "Real Estate",
        payload: {
            businessName: "Skyline Realty",
            industry: "Real Estate",
            subIndustry: "Property Agency",
            themeKey: "corporate-clean",
            desiredLayoutStyle: "marketplace",
            visualTone: "premium",
            preferredSectionDensity: "rich",
            brandStyle: "Corporate",
            toneOfVoice: "Professional",
            primaryGoal: "Generate Leads",
            primaryCallToAction: "Explore Properties",
            debugVariants: {
                "realestate-company-home-hero": 2,
                "realestate-company-home-market": 2,
                "realestate-company-home-listings": 2,
                "realestate-company-home-advisory": 2,
                "realestate-company-home-services": 2,
                "realestate-company-home-cta": 2
            },
            data: {
                brand: {
                    name: "Skyline Realty",
                    tagline: "Find your next perfect property."
                },
                meta: {
                    themeKey: "corporate-clean"
                },
                hero: {
                    eyebrow: "Premium Property Advisory",
                    title: "Find Verified Homes, Offices, and Investment Properties",
                    subtitle: "Discover curated listings with expert local guidance, transparent pricing, and fast site visits.",
                    primaryCta: "Explore Properties",
                    secondaryCta: "Book Consultation",
                    trustLine: "500+ verified listings across prime locations"
                },
                services: [
                    {
                        title: "Residential Properties",
                        description: "Apartments, villas, and premium homes matched to your lifestyle."
                    },
                    {
                        title: "Commercial Spaces",
                        description: "Offices, retail spaces, and investment-ready commercial assets."
                    },
                    {
                        title: "Property Consultation",
                        description: "Location, pricing, legal, and investment guidance from experts."
                    }
                ],
                features: [
                    {
                        title: "Verified Listings",
                        description: "Every property is checked before recommendation."
                    },
                    {
                        title: "Local Market Experts",
                        description: "Guidance based on city-level pricing and demand trends."
                    },
                    {
                        title: "Fast Site Visits",
                        description: "Schedule property visits quickly with our advisory team."
                    }
                ],
                cta: {
                    title: "Looking for the right property?",
                    subtitle: "Talk to our property advisor today.",
                    buttonText: "Book Consultation"
                },
                "ShowcaseItems": [
                    {
                        "Title": "3BHK Premium Apartment",
                        "Subtitle": "Satellite",
                        "Description": "Spacious apartment with modern amenities.",
                        "Meta": ["₹85L", "3 BHK", "1200 sqft"],
                        "Badge": "Verified"
                    },
                    {
                        "Title": "Luxury Villa",
                        "Subtitle": "Bopal",
                        "Description": "Independent villa with garden.",
                        "Meta": ["₹1.8Cr", "4 BHK", "3200 sqft"],
                        "Badge": "Premium"
                    }
                ]
            }
        }
    },

    commerce: {
        label: "Commerce",
        payload: {
            businessName: "Urban Threads Store",
            industry: "Ecommerce",
            subIndustry: "Clothing Store",
            themeKey: "premium-dark",
            desiredLayoutStyle: "commerce",
            visualTone: "premium",
            preferredSectionDensity: "rich",
            brandStyle: "Modern",
            toneOfVoice: "Bold",
            primaryGoal: "Drive Sales",
            primaryCallToAction: "Shop Now",

            debugVariants: {
                "commerce-home-hero": 2,
                "commerce-home-products": 2,
                "commerce-home-categorystrip": 2,
                "commerce-home-collections": 2,
                "commerce-home-truststrip": 2,
                "commerce-home-cta": 2
            },

            data: {
                brand: {
                    name: "Urban Threads",
                    tagline: "Style that speaks for you."
                },

                meta: {
                    themeKey: "premium-dark"
                },

                hero: {
                    eyebrow: "New Collection",
                    title: "Premium Streetwear for Everyday Style",
                    subtitle: "Discover curated outfits, limited drops, and modern fashion essentials.",
                    primaryCta: "Shop Now",
                    secondaryCta: "Explore Products",
                    trustLine: "Trusted by 10,000+ customers"
                },

                ShowcaseItems: [
                    {
                        Title: "Classic Black Hoodie",
                        Subtitle: "Winter Collection",
                        Description: "Premium cotton hoodie designed for comfort and street style.",
                        Meta: ["₹1,999", "Hoodie", "In Stock"]
                    },
                    {
                        Title: "Slim Fit Denim Jeans",
                        Subtitle: "Denim Series",
                        Description: "Stretchable slim-fit jeans with modern finish.",
                        Meta: ["₹2,499", "Jeans", "Limited Stock"]
                    },
                    {
                        Title: "Oversized Graphic T-Shirt",
                        Subtitle: "Summer Drop",
                        Description: "Relaxed fit t-shirt with bold graphic prints.",
                        Meta: ["₹1,199", "T-Shirt", "In Stock"]
                    }
                ],

                DetailDensity: {
                    Commerce: {
                        Products: [
                            {
                                Title: "Classic Black Hoodie",
                                Description: "Premium cotton hoodie designed for comfort and street style.",
                                PriceLabel: "₹1,999",
                                Category: "Hoodie",
                                StockLabel: "In Stock",
                                DiscountLabel: "20% OFF",
                                Tags: ["Cotton", "Winter", "Streetwear"]
                            },
                            {
                                Title: "Slim Fit Denim Jeans",
                                Description: "Stretchable slim-fit jeans with modern finish.",
                                PriceLabel: "₹2,499",
                                Category: "Jeans",
                                StockLabel: "Limited Stock",
                                DiscountLabel: "",
                                Tags: ["Denim", "Casual", "Stretch"]
                            }
                        ]
                    }
                }
            }
        }
    },

    legal: {
        label: "Legal",
        payload: {
            businessName: "Veritas Legal Partners",
            industry: "Legal",
            subIndustry: "Corporate Law Firm",
            themeKey: "luxury-light",
            desiredLayoutStyle: "trust-first",
            visualTone: "authoritative",
            preferredSectionDensity: "balanced",
            brandStyle: "Premium",
            toneOfVoice: "Professional",
            primaryGoal: "Book Appointments",
            primaryCallToAction: "Book Legal Consultation",
            data: {
                brand: {
                    name: "Veritas Legal Partners",
                    tagline: "Clear legal advice for complex decisions."
                },
                meta: {
                    themeKey: "luxury-light"
                },
                hero: {
                    eyebrow: "Corporate & Business Law",
                    title: "Trusted Legal Support for Companies, Founders, and Families",
                    subtitle: "Practical legal guidance across contracts, compliance, disputes, and advisory matters.",
                    primaryCta: "Book Legal Consultation",
                    secondaryCta: "View Practice Areas",
                    trustLine: "Trusted by startups, SMEs, and business owners"
                },
                services: [
                    {
                        title: "Corporate Advisory",
                        description: "Legal guidance for business formation, agreements, compliance, and governance."
                    },
                    {
                        title: "Contract Drafting",
                        description: "Clear, enforceable contracts for vendors, employees, partners, and clients."
                    },
                    {
                        title: "Dispute Resolution",
                        description: "Strategic support for commercial, civil, and business disputes."
                    }
                ],
                features: [
                    {
                        title: "Experienced Counsel",
                        description: "Work with lawyers who understand practical business risk."
                    },
                    {
                        title: "Confidential Process",
                        description: "Your legal matters are handled with privacy and care."
                    },
                    {
                        title: "Clear Next Steps",
                        description: "No confusing language. Just practical guidance."
                    }
                ],
                cta: {
                    title: "Need legal clarity?",
                    subtitle: "Schedule a confidential consultation.",
                    buttonText: "Book Consultation"
                },
                DetailDensity: {
                    Legal: {
                        PracticeAreas: [
                            {
                                Title: "Corporate Advisory",
                                Description: "Business formation, compliance, governance, and company documentation."
                            },
                            {
                                Title: "Contract Drafting",
                                Description: "Vendor, employee, partner, and client agreements drafted with clarity."
                            },
                            {
                                Title: "Dispute Resolution",
                                Description: "Strategic support for commercial, civil, and business disputes."
                            }
                        ],
                        Lawyers: [
                            {
                                Name: "Adv. Riya Mehta",
                                Role: "Corporate Lawyer",
                                Bio: "Advises startups and SMEs on contracts, governance, and compliance.",
                                Highlights: ["Corporate law", "Contracts", "Compliance"]
                            },
                            {
                                Name: "Adv. Arjun Shah",
                                Role: "Dispute Resolution Counsel",
                                Bio: "Supports businesses and families with civil and commercial disputes.",
                                Highlights: ["Civil disputes", "Commercial matters", "Negotiation"]
                            }
                        ]
                    }
                }
            }
        }
    },

    saas: {
        label: "SaaS",
        payload: {
            businessName: "FlowDesk AI",
            industry: "SaaS",
            subIndustry: "AI Productivity Platform",
            themeKey: "neo-gradient",
            desiredLayoutStyle: "saas",
            visualTone: "modern",
            preferredSectionDensity: "balanced",
            brandStyle: "Modern",
            toneOfVoice: "Bold",
            primaryGoal: "Book Demo",
            primaryCallToAction: "Book a Demo",
            data: {
                brand: {
                    name: "FlowDesk AI",
                    tagline: "Automate your team workflows."
                },
                meta: {
                    themeKey: "neo-gradient"
                },
                hero: {
                    eyebrow: "AI Workflow Automation",
                    title: "Automate Repetitive Work and Move Faster With AI",
                    subtitle: "FlowDesk AI helps teams manage tasks, approvals, documents, and customer workflows from one intelligent workspace.",
                    primaryCta: "Book a Demo",
                    secondaryCta: "See Features",
                    trustLine: "Built for growing teams and modern businesses"
                },
                services: [
                    {
                        title: "Workflow Automation",
                        description: "Automate approval flows, task routing, and internal operations."
                    },
                    {
                        title: "AI Document Assistant",
                        description: "Generate, summarize, and manage business documents faster."
                    },
                    {
                        title: "Team Dashboard",
                        description: "Track tasks, bottlenecks, and performance from one place."
                    }
                ],
                features: [
                    {
                        title: "AI-Powered Actions",
                        description: "Let AI suggest next steps and automate repetitive work."
                    },
                    {
                        title: "Role-Based Access",
                        description: "Control what each team member can view and manage."
                    },
                    {
                        title: "Real-Time Insights",
                        description: "Understand workflow performance instantly."
                    }
                ],
                cta: {
                    title: "Ready to automate your workflow?",
                    subtitle: "Book a demo and see FlowDesk AI in action.",
                    buttonText: "Book Demo"
                }
            }
        }
    },

    healthcare: {
        label: "Healthcare",
        payload: {
            businessName: "CarePlus Clinic",
            industry: "Healthcare",
            subIndustry: "Multi-Specialty Clinic",
            themeKey: "corporate-clean",
            desiredLayoutStyle: "healthcare",
            visualTone: "trustworthy",
            preferredSectionDensity: "balanced",
            brandStyle: "Professional",
            toneOfVoice: "Caring",
            primaryGoal: "Book Appointments",
            primaryCallToAction: "Book Appointment",
            debugVariants: {
                "healthcare-home-treatments": 2,
                "healthcare-home-doctors": 2,
                "healthcare-home-facilities": 2
            },
            data: {
                brand: { name: "CarePlus Clinic", tagline: "Patient-first care for every family." },
                meta: { themeKey: "corporate-clean" },
                hero: {
                    eyebrow: "Trusted Healthcare",
                    title: "Personalized Medical Care for Families and Professionals",
                    subtitle: "Consult experienced doctors, access essential treatments, and book appointments with ease.",
                    primaryCta: "Book Appointment",
                    secondaryCta: "View Doctors",
                    trustLine: "Trusted by 20,000+ patients"
                },
                features: [
                    { title: "Experienced Doctors", description: "Consult specialists across common care areas." },
                    { title: "Easy Appointments", description: "Book consultations quickly with minimal waiting." },
                    { title: "Modern Facilities", description: "Comfortable clinic environment and patient-first support." }
                ],
                services: [
                    { title: "General Consultation", description: "Diagnosis and guidance for common health concerns." },
                    { title: "Preventive Health Checkups", description: "Routine screening and health monitoring." },
                    { title: "Specialist Consultation", description: "Care from experienced specialists by appointment." }
                ],
                cta: {
                    title: "Need medical guidance?",
                    subtitle: "Book an appointment with our care team.",
                    buttonText: "Book Appointment"
                },
                DetailDensity: {
                    Healthcare: {
                        Treatments: [
                            {
                                Title: "General Consultation",
                                Subtitle: "Primary Care",
                                Description: "Routine diagnosis, prescriptions, and care guidance for common health issues.",
                                BestFor: "Families",
                                CtaText: "Book Appointment"
                            },
                            {
                                Title: "Preventive Health Checkup",
                                Subtitle: "Screening",
                                Description: "Basic screening packages to track health indicators and reduce future risk.",
                                BestFor: "Adults",
                                CtaText: "Book Checkup"
                            }
                        ],
                        Doctors: [
                            {
                                Name: "Dr. Aditi Sharma",
                                Specialty: "General Physician",
                                Bio: "Experienced physician focused on family care and preventive health.",
                                Availability: "Mon-Sat",
                                Highlights: ["10+ years experience", "Family medicine", "Preventive care"]
                            },
                            {
                                Name: "Dr. Rohan Mehta",
                                Specialty: "Internal Medicine",
                                Bio: "Specialist in lifestyle disorders, chronic care, and health management.",
                                Availability: "Tue-Sun",
                                Highlights: ["Chronic care", "Lifestyle health", "Patient-first approach"]
                            }
                        ],
                        Facilities: ["Consultation Rooms", "Diagnostics Support", "Pharmacy Assistance"]
                    }
                }
            }
        }
    },
};

const variantConfigs = {
    realEstate: [
        "realestate-company-home-hero",
        "realestate-company-home-market",
        "realestate-company-home-listings",
        "realestate-company-home-advisory",
        "realestate-company-home-services",
        "realestate-company-home-cta"
    ],
    academy: [
        "academy-home-hero",
        "academy-home-programs",
        "academy-home-categories",
        "academy-home-coaches",
        "academy-home-process",
        "academy-home-cta"
    ],
    commerce: [
        "commerce-home-hero",
        "commerce-home-products",
        "commerce-home-categorystrip",
        "commerce-home-collections",
        "commerce-home-truststrip",
        "commerce-home-cta"
    ],
    saas: [
        "saas-home-features",
        "saas-home-integrations",
        "saas-home-pricing"
    ],
    legal: [
        "legal-home-hero",
        "legal-home-practiceareas",
        "legal-home-lawyers",
        "legal-home-cta"
    ],
    healthcare: [
        "healthcare-home-treatments",
        "healthcare-home-doctors",
        "healthcare-home-facilities"
    ]
};

function getDefaultVariants(verticalKey) {
    const keys = variantConfigs[verticalKey] || [];
    return keys.reduce((acc, key) => {
        acc[key] = 2;
        return acc;
    }, {});
}

export default function DevPlaygroundPage() {
    const [selectedSample, setSelectedSample] = useState("academy");
    const [jsonText, setJsonText] = useState(
        JSON.stringify(
            {
                ...samples.academy.payload,
                debugVariants: getDefaultVariants("academy")
            },
            null,
            2
        )
    );

    const [html, setHtml] = useState("");
    const [htmlText, setHtmlText] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [previewUrl, setPreviewUrl] = useState("");
    const [previewPage, setPreviewPage] = useState("home");

    const [availablePages, setAvailablePages] = useState([
        { key: "home", title: "Home" }
    ]);

    const activeVariantKeys = useMemo(
        () => variantConfigs[selectedSample] || [],
        [selectedSample]
    );

    const parsedJson = useMemo(() => {
        try {
            return JSON.parse(jsonText);
        } catch {
            return null;
        }
    }, [jsonText]);

    const updateJson = (updater) => {
        try {
            const parsed = JSON.parse(jsonText);
            const next = updater(parsed);
            setJsonText(JSON.stringify(next, null, 2));
        } catch {
            setError("JSON is invalid. Fix JSON before using controls.");
        }
    };

    const updateVariant = (variantKey, value) => {
        updateJson((parsed) => ({
            ...parsed,
            debugVariants: {
                ...(parsed.debugVariants || {}),
                [variantKey]: Number(value)
            }
        }));
    };

    function getDefaultPages(verticalKey) {
        const pages = {
            commerce: [
                { key: "home", title: "Home" },
                { key: "products", title: "Products" },
                { key: "collections", title: "Collections" }
            ],

            academy: [
                { key: "home", title: "Home" },
                { key: "programs", title: "Programs" },
                { key: "coaches", title: "Coaches" },
                { key: "admissions", title: "Admissions" }
            ],

            realEstate: [
                { key: "home", title: "Home" },
                { key: "listings", title: "Listings" }
            ],
            saas: [
                { key: "home", title: "Home" },
                { key: "features", title: "Features" },
                { key: "pricing", title: "Pricing" },
                { key: "integrations", title: "Integrations" }
            ],
            legal: [
                { key: "home", title: "Home" },
                { key: "practice-areas", title: "Practice Areas" },
                { key: "team", title: "Legal Team" }
            ],
            healthcare: [
                { key: "home", title: "Home" },
                { key: "treatments", title: "Treatments" },
                { key: "doctors", title: "Doctors" }
            ]
        };

        return pages[verticalKey] || [{ key: "home", title: "Home" }];
    }

    const handleSampleChange = (key) => {
        const payload = {
            ...samples[key].payload,
            debugVariants: getDefaultVariants(key)
        };

        setSelectedSample(key);
        setPreviewPage("home");
        setAvailablePages(getDefaultPages(key));
        setJsonText(JSON.stringify(payload, null, 2));
        setHtml("");
        setHtmlText("");
        setError("");
    };

    const openPreviewInNewTab = (htmlContent) => {
        if (previewUrl) {
            URL.revokeObjectURL(previewUrl);
        }

        const blob = new Blob([htmlContent || ""], { type: "text/html" });
        const url = URL.createObjectURL(blob);

        setPreviewUrl(url);
        window.open(url, "_blank", "noopener,noreferrer");
    };

    const copyGeneratedHtml = async () => {
        try {
            await navigator.clipboard.writeText(htmlText || html || "");
            alert("Generated HTML copied!");
        } catch (error) {
            console.error(error);
            alert("Copy failed.");
        }
    };

    const handleRender = async () => {
        try {
            setLoading(true);
            setError("");

            const parsed = JSON.parse(jsonText);

            const payload = {
                ...parsed,
                previewPage
            };

            const result = await renderDevPreview(payload);
            const renderedHtml = result.html || "";

            setAvailablePages(result.pages || availablePages);
            setHtml(renderedHtml);
            setHtmlText(renderedHtml);

            openPreviewInNewTab(renderedHtml);
        } catch (err) {
            console.error(err);
            setError(err?.response?.data || err.message || "Failed to render preview.");
        } finally {
            setLoading(false);
        }
    };

    const selectedPageTitle =
        availablePages.find((x) => x.key === previewPage)?.title || previewPage;

    return (
        <PageShell title="Local Renderer Playground">
            <div style={styles.page}>
                <div style={styles.topBar}>
                    <div>
                        <h2 style={styles.title}>Renderer Playground</h2>
                        <p style={styles.subtitle}>
                            Test vertical shells, page variants, generated detail pages, and copy HTML output.
                        </p>
                    </div>

                    <div style={styles.actions}>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={copyGeneratedHtml}
                            disabled={!htmlText && !html}
                        >
                            Copy HTML
                        </button>

                        <button
                            className="btn btn-primary"
                            onClick={handleRender}
                            disabled={loading}
                        >
                            {loading ? "Rendering..." : "Render Preview"}
                        </button>
                    </div>
                </div>

                <div style={styles.controlsCard}>
                    <label style={styles.field}>
                        <span>Vertical</span>
                        <select
                            value={selectedSample}
                            onChange={(e) => handleSampleChange(e.target.value)}
                            style={styles.select}
                        >
                            {Object.entries(samples).map(([key, sample]) => (
                                <option key={key} value={key}>
                                    {sample.label}
                                </option>
                            ))}
                        </select>
                    </label>

                    <label style={styles.field}>
                        <span>Preview Page</span>
                        <select
                            value={previewPage}
                            onChange={(e) => setPreviewPage(e.target.value)}
                            style={styles.select}
                        >
                            {availablePages.map((p) => (
                                <option key={p.key} value={p.key}>
                                    {p.title || p.key}
                                </option>
                            ))}
                        </select>
                    </label>

                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => handleSampleChange(selectedSample)}
                    >
                        Reset Sample
                    </button>
                </div>

                {activeVariantKeys.length > 0 && (
                    <div style={styles.variantPanel}>
                        <div style={styles.variantHeader}>
                            <strong>Shell Variants</strong>
                            <span>Current page: {selectedPageTitle}</span>
                        </div>

                        <div style={styles.variantGrid}>
                            {activeVariantKeys.map((variantKey) => (
                                <label key={variantKey} style={styles.variantControl}>
                                    <span>{variantKey}</span>
                                    <select
                                        value={parsedJson?.debugVariants?.[variantKey] ?? 2}
                                        onChange={(e) => updateVariant(variantKey, e.target.value)}
                                        style={styles.variantSelect}
                                    >
                                        <option value={1}>Variant 1</option>
                                        <option value={2}>Variant 2</option>
                                        <option value={3}>Variant 3</option>
                                    </select>
                                </label>
                            ))}
                        </div>
                    </div>
                )}

                {error && <div style={styles.error}>{String(error)}</div>}

                <div style={styles.grid}>
                    <section style={styles.panel}>
                        <div style={styles.panelHeader}>
                            <div>
                                <h3 style={styles.panelTitle}>Input JSON</h3>
                                <p style={styles.panelHint}>Edit manually or use variant controls above.</p>
                            </div>
                        </div>

                        <textarea
                            value={jsonText}
                            onChange={(e) => setJsonText(e.target.value)}
                            spellCheck={false}
                            style={styles.textarea}
                        />
                    </section>

                    <section style={styles.panel}>
                        <div style={styles.panelHeader}>
                            <div>
                                <h3 style={styles.panelTitle}>Generated HTML</h3>
                                <p style={styles.panelHint}>
                                    Rendered page: {selectedPageTitle}
                                </p>
                            </div>
                        </div>

                        {html ? (
                            <textarea
                                value={htmlText}
                                readOnly
                                spellCheck={false}
                                style={styles.textarea}
                            />
                        ) : (
                            <div style={styles.empty}>
                                Choose a vertical and click Render Preview.
                            </div>
                        )}
                    </section>
                </div>
            </div>
        </PageShell>
    );
}

const styles = {
    page: {
        display: "grid",
        gap: 16
    },
    topBar: {
        display: "flex",
        justifyContent: "space-between",
        gap: 16,
        alignItems: "center"
    },
    title: {
        margin: 0,
        fontSize: 26,
        letterSpacing: "-0.04em"
    },
    subtitle: {
        margin: "6px 0 0",
        color: "#64748b"
    },
    actions: {
        display: "flex",
        gap: 10,
        flexWrap: "wrap"
    },
    controlsCard: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr auto",
        gap: 12,
        alignItems: "end",
        padding: 16,
        borderRadius: 18,
        background: "#fff",
        border: "1px solid #e5e7eb",
        boxShadow: "0 12px 30px rgba(15,23,42,.06)"
    },
    field: {
        display: "grid",
        gap: 6,
        fontSize: 13,
        fontWeight: 700,
        color: "#475569"
    },
    select: {
        minHeight: 44,
        border: "1px solid #d1d5db",
        borderRadius: 12,
        padding: "10px 12px",
        background: "#fff"
    },
    variantPanel: {
        padding: 16,
        borderRadius: 18,
        background: "#0f172a",
        color: "#fff",
        boxShadow: "0 18px 44px rgba(15,23,42,.18)"
    },
    variantHeader: {
        display: "flex",
        justifyContent: "space-between",
        gap: 12,
        marginBottom: 12,
        color: "#e2e8f0"
    },
    variantGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
        gap: 10
    },
    variantControl: {
        display: "grid",
        gap: 6,
        padding: 12,
        borderRadius: 14,
        background: "rgba(255,255,255,.08)",
        border: "1px solid rgba(255,255,255,.12)",
        fontSize: 12
    },
    variantSelect: {
        minHeight: 38,
        border: "1px solid rgba(255,255,255,.18)",
        borderRadius: 10,
        padding: "8px 10px",
        background: "#fff",
        color: "#111827"
    },
    error: {
        background: "#fee2e2",
        color: "#991b1b",
        padding: 12,
        borderRadius: 14,
        whiteSpace: "pre-wrap"
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 16,
        height: "calc(100vh - 360px)",
        minHeight: 520
    },
    panel: {
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        borderRadius: 18,
        background: "#fff",
        border: "1px solid #e5e7eb",
        overflow: "hidden",
        boxShadow: "0 12px 30px rgba(15,23,42,.06)"
    },
    panelHeader: {
        padding: "14px 16px",
        borderBottom: "1px solid #e5e7eb",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
    panelTitle: {
        margin: 0,
        fontSize: 16
    },
    panelHint: {
        margin: "4px 0 0",
        color: "#64748b",
        fontSize: 12
    },
    textarea: {
        flex: 1,
        width: "100%",
        resize: "none",
        border: "none",
        padding: 16,
        fontFamily: "Consolas, monospace",
        fontSize: 12,
        lineHeight: 1.55,
        outline: "none"
    },
    empty: {
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#64748b"
    }
};